import script from "./AnimationPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimationPlayer.vue?vue&type=script&setup=true&lang=js"

import "./AnimationPlayer.vue?vue&type=style&index=0&id=a8a5a890&lang=css"

const __exports__ = script;

export default __exports__